module.exports = __webpack_public_path__ + "static/media/S (8).3ab4005c.jpg";